import { fetchGetters } from '@/store/extensions/fetch';
import { createGetters } from '@/store/extensions/create';
import { updateGetters } from '@/store/extensions/update';

export default {
  ...fetchGetters,
  ...createGetters,
  ...updateGetters,
  starting: state => state.starting,
  stopping: state => state.stopping,
  formModalOpened: state => state.formModalOpened,
  current: state => state.current,
  currentEntity: (state, getters) => (
    state.current ? getters.find(state.current) : null
  ),
  detailsModalOpened: state => state.detailsModalOpened,
  manualModalOpened: state => state.manualModalOpened,
  currentTimeLog: (state, getters) => (
    getters.current ? getters.find(getters.current) : null
  ),
};



// WEBPACK FOOTER //
// ./src/store/modules/timeLog/getters.js